import api from "src/configs/api";
import { GET_ALL_TAGS, GET_TAGS_BY_RESOURCES, UPDATE_RESOURCE_TAG } from "src/constant/endpoint";

const getAllTags = async (params) => await api.get(GET_ALL_TAGS, { params }).then((response) => response?.data?.data);

const getTagsByResources = async (params) => await api.get(GET_TAGS_BY_RESOURCES, { params }).then((response) => response?.data);

const updateResourceTag = async ({ data }) => await api.post(UPDATE_RESOURCE_TAG, { data }).then((response) => response?.data);

const deleteResourceTag = async (params) => await api.delete(UPDATE_RESOURCE_TAG, { params }).then((response) => response?.data);

export { getAllTags, getTagsByResources, updateResourceTag, deleteResourceTag };
